import React, { useState, useEffect } from 'react'; 
import { withTranslation } from 'react-i18next';
import { gql, useApolloClient, useLazyQuery, useQuery } from '@apollo/client';
import Header from '../components/Headers/Header';
import CustomLoader from '../components/Loader/CustomLoader';
import { FilterProductsByCategories, getlocaladminproducts, searchproductls } from '../apollo';
import DataTable from 'react-data-table-component';
import orderBy from 'lodash/orderBy';
import SearchBar from '../components/TableHeader/SearchBar';
import { customStyles } from '../utils/tableForManageProductsForLS';
import useGlobalStyles from '../utils/globalStyles';
import {
    Container,
    Modal,
    MenuItem,
    IconButton,
    Menu,
    ListItemIcon,
    Typography, Button,
    Paper, Box, Badge,
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import TableHeader from '../components/TableHeader';
import CSSku from '../components/AddSKU/CSSku';
import EditProductLs from '../components/AddProduct/EditProductLs';
import AllPRoductFIlter from '../utils/fIlters/AllPRoductFIlter';


const GET_PRODUCTS = gql`
  ${getlocaladminproducts}
`;
const GET_SEARCH_PRODUCTS = gql`
  ${searchproductls}
`;
const GET_ALL_PRODUCT_filter = gql`
${FilterProductsByCategories}
`;

const LocalAdminProducts = props => {
    const { t } = props;
    const [editModal, setEditModal] = useState(false);
    const [vendors, setVendor] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [skuModal, setSkuModal] = useState(false);
    const userDetailsStr = localStorage.getItem('user-native');
    const userDetails = JSON.parse(userDetailsStr);
    const golbalClasses = useGlobalStyles();

    // State for pagination and filters
    const [badgeContent, setBadgeContent] = useState(false);
    const [page, setPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1); 
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [tabledata, setTabledata] = useState(null);
    const [OpenFilter, setOpenFilter] = useState(false);
    const [FilterPaload, setFilterPaload] = useState({}); 
    const [DefaultValue, setDefaultValue] = useState({}); 

    const [isLoadingData, setIsLoadingData] = useState(false); 

    const client = useApolloClient();

    const closeEditModal = () => {
        setEditModal(false);
    };
    const closeSkuModal = () => {
        setSkuModal(false);
    };
    const handleOpenFilter = () => {
        setOpenFilter(true);
    };
    const CloseFilter = () => {
        setOpenFilter(false);
    };

   const handleResetFilters = async () => {
    setFilterPaload({});
    setDefaultValue({});
    setPage(1);
    setCurrentPage(1);
    setSearchQuery('');
    setBadgeContent(false);

    await refetchAllProducts({
        variables: {
            storeId: userDetails.storeId,
            limit: perPage,
            skip: 0,
        },
    });
};

  
    const [fetchFilteredProducts, { error: errorFiltered, data: dataFiltered }] = useLazyQuery(GET_ALL_PRODUCT_filter, {
        fetchPolicy: 'network-only', // Always fetch fresh data for filters
        onCompleted: (resultData) => {
            if (resultData && resultData.filterProductsByCategories) {
                setTabledata(resultData.filterProductsByCategories.products || []);
                setTotalRows(resultData.filterProductsByCategories.totalCount || 0);
            }
        },
        onError: error => {
            const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
            if (isForbiddenError) {
                localStorage.removeItem('user-native');
                localStorage.removeItem('restaurant_id');
                client.clearStore();
                props.history.push('/auth/login');
            }
        },
    });

   
    const { error: errorAllProducts, data: dataAllProducts, refetch: refetchAllProducts } = useQuery(
        GET_PRODUCTS,
        {
            variables: {
                storeId: userDetails.storeId,
                limit: perPage,
                skip: (page - 1) * perPage,
            },
            fetchPolicy: "network-only",
            skip: true, // IMPORTANT: Skip initial fetch and let useEffect control
            onCompleted: (data) => {
                if (!badgeContent && !searchQuery) {
                    setTabledata(data && data.getProductsForLS.products ? data.getProductsForLS.products : []);
                    setTotalRows(data.getProductsForLS.totalCount);
                }
            },
            onError: error => {
                const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
                if (isForbiddenError) {
                    localStorage.removeItem('user-native');
                    localStorage.removeItem('restaurant_id');
                    client.clearStore();
                    props.history.push('/auth/login');
                }
            },
        }
    );

    
    const { error: errorSearch, data: dataSearch, refetch: refetchSearch } = useQuery(
        GET_SEARCH_PRODUCTS, {
            variables: {
                text: searchQuery,
                limit: perPage,
                skip: (page - 1) * perPage,
            },
            fetchPolicy: "network-only",
            skip: true, // IMPORTANT: Skip initial fetch and let useEffect control
            onCompleted: (data) => {
                if (searchQuery && !badgeContent) {
                    setTabledata(data && data.searchProductsLS.products ? data.searchProductsLS.products : []);
                    setTotalRows(data.searchProductsLS.totalCount);
                }
            },
            onError: error => {
                const isForbiddenError = error && error.graphQLErrors.some(err => err.extensions.code === 'FORBIDDEN');
                if (isForbiddenError) {
                    localStorage.removeItem('user-native');
                    localStorage.removeItem('restaurant_id');
                    client.clearStore();
                    props.history.push('/auth/login');
                }
            },
        }
    );

    
    useEffect(() => {
        const fetchData = async () => {
            setIsLoadingData(true); // Start loading
            try {
                if (badgeContent) {
                    await fetchFilteredProducts({
                        variables: {
                            ...FilterPaload, // Use the stored filter payload
                            limit: perPage,
                            skip: (page - 1) * perPage,
                        },
                    });
                } else if (searchQuery) {
                    await refetchSearch({
                        variables: {
                            text: searchQuery,
                            limit: perPage,
                            skip: (page - 1) * perPage,
                        },
                    });
                } else {
                    await refetchAllProducts({
                        variables: {
                            storeId: userDetails.storeId,
                            limit: perPage,
                            skip: (page - 1) * perPage,
                        },
                    });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                
            } finally {
                setIsLoadingData(false); // End loading regardless of success or failure
            }
        };

        fetchData(); // Call the async function
    }, [page, perPage, badgeContent, searchQuery, FilterPaload, refetchAllProducts, refetchSearch, fetchFilteredProducts, userDetails.storeId]);


    const filterData = (filterInput) => {
        setDefaultValue(filterInput);

        const newFilterPayload = {
            categoryId: filterInput.orderStatus,
            subCategoryId: filterInput.workerStatus,
        };
        setFilterPaload(newFilterPayload);
        setBadgeContent(true);
        setPage(1);
        setCurrentPage(1);
        setSearchQuery('');
        CloseFilter();
    };

    const onChangeSearch = e => {
        const value = e.target.value;
        setSearchQuery(value); // This updates the input field immediately
        setPage(1);
        setCurrentPage(1);
        setBadgeContent(false);
        setFilterPaload({});
        setDefaultValue({});
    };

    // If you decide to debounce, modify onChangeSearch to use this:
    /*
    const debouncedSetSearchQuery = useCallback(
        debounce((value) => {
            setSearchQuery(value);
            setPage(1);
            setCurrentPage(1);
            setBadgeContent(false);
            setFilterPaload({});
            setDefaultValue({});
        }, 300), // Debounce for 300ms
        []
    );

    const onChangeSearch = e => {
        debouncedSetSearchQuery(e.target.value);
    };
    */

const onClickRefetch = async () => {
    console.log("Refresh button clicked! Resetting all states.");
    setSearchQuery('');
    setPage(1);
    setCurrentPage(1);
    setBadgeContent(false);
    setFilterPaload({});
    setDefaultValue({});

    await refetchAllProducts({
        variables: {
            storeId: userDetails.storeId,
            limit: perPage,
            skip: 0,
        },
    });
};
    const handlePerRowChange = (newPerPage) => {
        setPerPage(newPerPage);
        //setPage(1);
        //setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        setPage(newPage);
        setCurrentPage(newPage);
    };

    const toggleModal = vendor => {
        setEditModal(!editModal);
        setVendor(vendor);
    };

    useEffect(() => {
      localStorage.removeItem('restaurant_id');
    }, []);

    const customSort = (rows, field, direction) => {
        const handleField = row => {
            if (row[field]) {
                return String(row[field]).toLowerCase();
            }
            return row[field];
        };
        return orderBy(rows, handleField, direction);
    };

  const columns = [
        {
            name: "Product ID",
            selector: '_id'
        },
        {
            name: "Product Name",
            sortable: true,
            selector: 'displayName',
            style: { cursor: 'pointer', minWidth: "250px" },
        },
        {
            name: "Quantity",
            selector: 'skus',
            cell: row => {
                return row.skus.filter(sku => sku.isActive).map(sku => {
                    const localStock = sku.localStocks.find(stock => stock.storeId === userDetails.storeId);
                    return localStock ? localStock.quantity : 0;
                }).join(', ');
            },
            sortable: false
        },
        {
            name: "Aliases",
            sortable: false,
            cell: row => row.aliases.join(', ')
        },
        {
            name: "Catalog Name",
            sortable: true,
            selector: 'catalog.name',
            style: { cursor: 'pointer', minWidth: "300px" },
        },
        {
            name: "Category",
            sortable: true,
            selector: 'category.name',
            style: { cursor: 'pointer', minWidth: "300px" },
        },
        {
            name: "Default Image",
            sortable: false,
            cell: row => (
                <img
                    src={row.defaultImage}
                    alt={row.displayName}
                    style={{ width: 50, height: 50 }}
                />
            )
        },
        {
            name: "HSN",
            sortable: true,
            selector: 'hsn'
        },
        {
            name: t('Action'),
            cell: row => <>{actionButtons(row)}</>
        }
    ];
    const actionButtons = row => {
        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);
        const handleClick = event => {
            setAnchorEl(event.currentTarget);
        };
        const handleClose = () => {
            setAnchorEl(null);
        };
        return (
            <>
                <div>
                    <IconButton
                        aria-label="more"
                        id="long-button"
                        aria-haspopup="true"
                        onClick={handleClick}>
                        <MoreVertIcon fontSize="small" />
                    </IconButton>
                    <Paper>
                        <Menu
                            id="long-menu"
                            MenuListProps={{
                                'aria-labelledby': 'long-button'
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}>
                            <MenuItem
                                onClick={e => {
                                    e.preventDefault();
                                    handleClose();
                                    toggleModal(row);
                                }}
                                style={{ height: 25 }}>
                                <ListItemIcon>
                                    <EditIcon fontSize="small" style={{ color: 'green' }} />
                                </ListItemIcon>
                                <Typography color="green">{t('Edit')}</Typography>
                            </MenuItem>
                        </Menu>
                    </Paper>
                </div>
            </>
        );
    };

  
   
    const currentError = errorAllProducts || errorSearch || errorFiltered;

    return (
        <>
            <Header />
            <Container className={golbalClasses.flex}>
                {/* Removed the global CustomLoader here */}
                {currentError ? <span> `Error! ${currentError.message}`</span> : null}
                <div>
                    <DataTable
                        subHeader={true}
                        subHeaderComponent={
                            <>
                                <SearchBar
                                    value={searchQuery}
                                    onChange={onChangeSearch}
                                    onClick={onClickRefetch}
                                />
                                <Box style={{ marginTop: -40 }}>
                                    {badgeContent ? (
                                        <Badge
                                            badgeContent={''}
                                            color="success"
                                            variant="dot"
                                            anchorOrigin={{
                                                vertical: 'top',
                                                horizontal: 'center',
                                            }}
                                        >
                                            <Button
                                                onClick={handleOpenFilter}
                                            >
                                                <TuneIcon />
                                            </Button>
                                        </Badge>
                                    ) : (
                                        <Button
                                            onClick={handleOpenFilter}
                                        >
                                            <TuneIcon />
                                        </Button>
                                    )}
                                </Box>
                            </>
                        }
                        title={<TableHeader title={t('LS Manage Products ')} />}
                        columns={columns}
                        data={tabledata || []}
                        progressPending={isLoadingData} 
                        progressComponent={<CustomLoader />} 
                        paginationDefaultPage={currentPage}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangeRowsPerPage={handlePerRowChange}
                        onChangePage={handlePageChange}
                        sortFunction={customSort}
                        customStyles={customStyles}
                    />
                </div>
                <Modal
                    open={editModal}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onClose={() => {
                        toggleModal();
                    }}>
                    <EditProductLs vendor={vendors} onClose={closeEditModal} refetch={onClickRefetch} />
                </Modal>
                <Modal
                    open={skuModal}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    onClose={() => {
                        setSkuModal(false);
                    }}>
                    <CSSku vendor={vendors} onClose={closeSkuModal} refetch={onClickRefetch} />
                </Modal>

                {OpenFilter &&
                    <AllPRoductFIlter
                        open={OpenFilter}
                        close={CloseFilter}
                        filterData={filterData}
                        DefaultValue={DefaultValue}
                        handleResetFilters={handleResetFilters}
                    />
                }
            </Container>
        </>
    );
};

export default withTranslation()(LocalAdminProducts);
